export default class Helper {
    static constructOrderItemsFromCart(response, oldItem) {
      var orderItem = {};
      
      //plan
      orderItem.plan = Object.assign({}, response.plan);
      orderItem.plan.type = "plan";
      orderItem.plan.initialQuantity = oldItem && oldItem.plan.initialQuantity ? oldItem.plan.initialQuantity : response.plan.quantity;
      orderItem.plan.quantity_meta_overrides = oldItem && oldItem.plan.quantity_meta_overrides;

      //addons
      orderItem.addons = Object.assign([], response.addons);
      orderItem.addons.forEach(addon => {
          if(oldItem) {
              let oldAddon = oldItem.addons.filter(a => a.id == addon.id)[0];
              addon.initialQuantity = oldAddon ? (oldAddon.initialQuantity || oldAddon.quantity) : addon.quantity;
              addon.quantity_meta_overrides = oldAddon && oldAddon.quantity_meta_overrides
          } else {
              addon.initialQuantity = addon.quantity;
          }
          addon.type = "addon";
      });

      //coupons
      orderItem.coupon_list = Object.assign([], response.coupons);
      orderItem.coupon_list.forEach(coupon => coupon.type = "coupon");

      orderItem.coupon = orderItem.coupon_list[0] && orderItem.coupon_list[0].id;

      if(oldItem.replace_coupon_list) {
        orderItem.replace_coupon_list = true;
      }

      if(oldItem.replace_addon_list) {
        orderItem.replace_addon_list = true;
      }

      return orderItem;
  }


  static constructOrderItems(hostedPage) {
    var orderItem = {
      plan: {
        id: hostedPage.subscription && hostedPage.subscription.plan_id,
        quantity: hostedPage.subscription && hostedPage.subscription.plan_quantity,
        type: "plan",
        initialQuantity: hostedPage.subscription && hostedPage.subscription.plan_quantity
      }
    }
    orderItem.addons = hostedPage.addons;
    orderItem.addons.forEach(addon => {
      addon.initialQuantity = addon.quantity;
      addon.type = "addon";
    });
    orderItem.coupon = hostedPage.coupon;
    return orderItem;
  }

  static constructOrderItemsFromSubscription(subscription) {
    var orderItem = {
      plan: {
        id: subscription.plan_id,
        quantity: subscription.plan_quantity,
        type: "plan",
        initialQuantity: subscription.plan_quantity
      }
    }

    orderItem.addons = subscription.addons || [];
    orderItem.addons.forEach(addon => {
      addon.type = "addon";
      addon.initialQuantity = addon.quantity;
    });
    return orderItem;
  }

  static constructOrderItemsFromEstimate(estimate, subscription) {
    var orderItem = { addons: []}
    estimate.line_items.forEach((line_item) => {
      if(line_item.entity_type == "plan") {
        orderItem["plan"] = this.constructItem("plan", line_item, estimate);
      }

      if(line_item.entity_type == "plan_setup") {
        orderItem["plan_setup"] = {
          type: "plan_setup",
          id: line_item.entity_id,
          lineItem: line_item,
        }
      }

      if(line_item.entity_type == "addon") {
        orderItem["addons"].push(this.constructItem("addon", line_item, estimate));
      }
    });

    // In case of hide zero dollar setting, plan line item would not be present
    if(!orderItem.plan && subscription) {
      orderItem.plan = {
        id: subscription.plan_id,
        quantity: subscription.plan_quantity,
        initialQuantity: subscription.quantity,
        type: "plan"
      }
    }

    // NOT STORING COUPON IN ORDER ITEM - bcoz of expired coupons - cart update api will return valid coupons

    // add discounts
    // add coupon only if only one discount is present
    // multiple coupons scenario will be handled differently
    // if(estimate.discounts && estimate.discounts.length == 1) {
    //   var discount = estimate.discounts[0];
    //   if(["item_level_coupon", "document_level_coupon"].indexOf(discount.entity_type) > -1) {
    //     orderItem.coupon = discount.entity_id;
    //   }
    // }

    return orderItem;
  }

  static constructItem(type, line_item, estimate) {
    return {
        type: type,
        id: line_item.entity_id,
        lineItem: line_item,
        quantity: line_item.quantity,
        initialQuantity: line_item.quantity,
        pricing_model: line_item.pricing_model,
        unit_amount: line_item.unit_amount,
        amount: line_item.amount,
        tiers: ((estimate.line_item_tiers && estimate.line_item_tiers.filter(t => t.line_item_id == line_item.id)) || [])
    }
  }

  static constructAddons(data) {
    var output = [];
    var tmpMap = {};
    this.getAddonFields(data).forEach((key) => {
      let tmp = key.match(/addons\[(.*)\]\[(.*)\]/) && key.match(/addons\[(.*)\]\[(.*)\]/).slice(1);
      if(!['id', 'quantity'].includes(tmp[0])){
        return;
      }
      if(tmp.length == 2){
        if(!tmpMap[tmp[1]]) {
          tmpMap[tmp[1]] = {};
          output.push(tmpMap[tmp[1]]);
        }
        tmpMap[tmp[1]][tmp[0]] = this._getField(data, key);
      }
    });
    return output;
  }

  static constructPlanSetup(planSetupLineItem) {
    if(!planSetupLineItem) return;
    return {
      type: "plan_setup",
      id: planSetupLineItem.entity_id,
      lineItem: planSetupLineItem,
      amount: planSetupLineItem && planSetupLineItem.amount
    }
  }

  static getAddonFields(hostedPage) {
    return Object.keys(hostedPage).filter(param => param.startsWith("addons"));
  }

  static _getField(data, field) {
    return data[field];
  }

  static getCurrentTimestamp(){
    return new Date().getTime();
  }
}


// WEBPACK FOOTER //
// ./src/utils/hosted-page-helper.js